// extracted by mini-css-extract-plugin
export default {"dot":"index_dot_dHB-0","current":"index_current_RMVsj index_dot_dHB-0"};